var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-info"},[_c('img',{staticClass:"panel-info-img",attrs:{"src":"/images/i-pin-yellow.png","alt":"info"}}),_vm._t("default"),_c('div',[_vm._t("additional")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }